<div class="p-fluid">
    <form [formGroup]="revaiForm" class="p-field p-grid">
        <div class="p-field p-col-12">
            <label><strong>Rev.ai API access token(find that at <a
                        href="https://www.rev.ai/access_token">https://www.rev.ai/access_token</a></strong></label>
            <textarea pInputTextarea [rows]="3" [cols]="50" formControlName="revai_access_token"></textarea>
        </div>
        <div class="p-field p-col-12">
            <label><strong>Youtube Closed Caption Link</strong><i>(ex:
                    https://upload.youtube.com/closedcaption?cid=xxxx-xxxx-xxxx-xxxx-xxxx)</i></label>
            <textarea pInputTextarea [rows]="3" [cols]="50" formControlName="youtube_link"></textarea>
        </div>
        <div class="p-col-12 p-md-3" *ngIf="revaiForm.disabled">
            <button pButton label="Edit" class="p-button-rounded p-button-info"
                (click)="editAccessToken($event)"></button>
        </div>
        <div class="p-col-12 p-md-3" *ngIf="revaiForm.enabled">
            <button pButton label="Save" class="p-button-rounded p-button-success"
                (click)="saveAccessToken($event)"></button>
        </div>
        <div class="p-col-12 p-md-3" *ngIf="revaiForm.enabled">
            <button pButton label="Cancel" class="p-button-rounded p-button-warning p-button-outlined"
                (click)="cancelAccessToken($event)"></button>
        </div>
    </form>
    <form [formGroup]="ingestionForm" class="p-field p-grid">
        <div class="p-field p-col-12">
            <label><strong>Realtime ingestion URL(for Streamtext.net)</strong></label>
            <textarea pInputTextarea [rows]="3" [cols]="50" formControlName="ingestion_url"></textarea>
        </div>
        <div class="p-col-12 p-md-6">
            <button pButton label="Generate a new URL" class="p-button-rounded p-button-info"
                (click)="generateNewUrl($event)"></button>
        </div>
    </form>
    <div class="p-field">
        <p>To use out Twitch extension, you must login with Twitch so that we can connect your account to our system</p>
    </div>
    <button type="button" class="p-button-twitch">
        <span class="ui-button-icon-left ui-c fa fa-fw fa-twitch"></span>
        <span class="ui-button-text ui-c">Log in with Twitch</span>
    </button>
</div>